import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AuthAPI } from "../../../services/auth";
import Toast from "../../../helpers/status-text";
import Button from "../../ui/button/button";

import styles from "./styles.module.scss";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userName = localStorage.getItem("user_name");
  const { isAuth } = useSelector((state) => state.auth);

  const handleLogout = useCallback(() => {
    (async () => {
      try {
        await dispatch(AuthAPI.logout()).unwrap();
        localStorage.clear();
        navigate("/login");
      } catch (error) {
        Toast.error(error.message);
      }
    })();
  }, [dispatch, navigate]);

  return (
    <header className={styles.header}>
      <Link to={isAuth ? "/home" : "/login"}>
        <img width={110} alt="Nor Tun logo" src="/svg/logo.svg" />
      </Link>
      {isAuth && (
        <div className={styles.dropdown_block}>
          <input
            type="checkbox"
            id="dropdown-toggle"
            className={styles.dropdown_checkbox}
          />
          <label htmlFor="dropdown-toggle" className={styles.icon}>
            <img
              alt="Personal Center"
              src="/svg/personal-center.svg"
              className={styles.personal_img}
            />
            <span>{userName}</span>
            <img
              alt="dropdown"
              src="/svg/down.svg"
              className={styles.down_icon}
            />
          </label>
          <ul className={styles.drop_menu}>
            <li>
              <Button
                type="button"
                onClick={handleLogout}
                className={styles.logout_btn}
              >
                Log Out
              </Button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
